import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { ServicesProvider } from "@/contexts/ServicesContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <SettingsProvider>
      <ServicesProvider>
        <div className="min-h-screen flex flex-col bg-white" data-testid="site-layout">
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Outlet />
          </main>
          <Footer />
        </div>
      </ServicesProvider>
    </SettingsProvider>
  );
}
